import { useSelector } from 'react-redux';
import {
    selectedIsClusteringUnassignedTasks,
    selectMapMarkerMode,
    selectMapRouteMode
} from '~/reducers/mapSettingsSlice';
import type { ConfigurableMapRouteMode } from '~/reducers/mapSettingsSlice/types';
import { MapMarkerModes, MapRouteModes } from './types';

/**
 * Expected hook returns from `useMapUtils`
 */
type HookMapUtils = {
    isClusteringUnassignedTasks?: boolean;
    isStopsClustersMode: boolean;
    isPlanRouteMode: boolean;
    isPreRoutePlanningMode: boolean;
    isOnDemandDispatchMode: boolean;
    isLiveRouteMode: boolean;
    isDispatchedRouteMode: boolean;
    isCompletedRouteMode: boolean;
    mapMarkerMode: MapMarkerModes;
    mapRouteMode: MapRouteModes;
    isRoutesMode: boolean;
    isEmptyRouteMode: boolean;
};

export const useMapUtils = (): HookMapUtils => {
    const mapMarkerMode = useSelector(selectMapMarkerMode) as MapMarkerModes;
    const mapRouteMode = useSelector(selectMapRouteMode) as MapRouteModes;

    const isClusteringUnassignedTasks = useSelector(
        selectedIsClusteringUnassignedTasks(
            mapRouteMode as unknown as ConfigurableMapRouteMode
        )
    );

    const isStopsClustersMode = mapMarkerMode === MapMarkerModes.STOPS_CLUSTERS;

    const isRoutesMode = mapMarkerMode === MapMarkerModes.ROUTES;

    const isPreRoutePlanningMode = [
        MapRouteModes.PLAN,
        MapRouteModes.EMPTY
    ].includes(mapRouteMode);

    const isOnDemandDispatchMode = [
        MapRouteModes.PLAN,
        MapRouteModes.DISPATCHED
    ].includes(mapRouteMode);

    const isLiveRouteMode = [
        MapRouteModes.COMPLETED,
        MapRouteModes.DISPATCHED
    ].includes(mapRouteMode);

    const isEmptyRouteMode = mapRouteMode === MapRouteModes.EMPTY;
    const isPlanRouteMode = mapRouteMode === MapRouteModes.PLAN;
    const isDispatchedRouteMode = mapRouteMode === MapRouteModes.DISPATCHED;
    const isCompletedRouteMode = mapRouteMode === MapRouteModes.COMPLETED;

    return {
        isClusteringUnassignedTasks,
        isStopsClustersMode,
        isPlanRouteMode,
        isPreRoutePlanningMode,
        isOnDemandDispatchMode,
        isLiveRouteMode,
        isDispatchedRouteMode,
        isCompletedRouteMode,
        mapMarkerMode,
        mapRouteMode,
        isRoutesMode,
        isEmptyRouteMode
    };
};
